const visitorLogin = {
  msg: {
    mobilePhone: '手机号',
    userName: '姓名',
    submit: '提交',
    enterMobilePhone: '请输入手机号',
    mobilePhoneMinLength: '手机号至少7位',
    enterName: '请输入姓名',
    switchLang: 'English'
  }
};
export default visitorLogin



// WEBPACK FOOTER //
// ./src/page/visitor/visitorLogin/lang/visitorLogin.zh.js